import r from "./_createCaseFirst.js";
var e = r("toUpperCase");
const p = e;
export {
  p as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/upperFirst.js
// module id = 1532
// module chunks = 41